<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list row-key="PropertyId" ref="list" unit="用户" :expand-all-row="true" :page="page"
      :show-checkbox="!is_listDialog && isShow" :show-query="true" :queryParamsAppend="params"
       urlHash="business/sales/sale" @showRow="toggleRow" :showTrendTable="isShow"
      :temp-params="tempParams" 
      :summary-method="summaryFunc"
      :show-summary="summaryShow"
      :get-data-func="getDataFunc"
      >
      <!-- :get-data-func="api.docList" -->
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="业务类型" label-width="85px">
          <el-select
            v-model="params.BusinessTypeId"
            clearable
            :disabled="isSelect"
          >
            <el-option
              v-for="item in businessTypeList"
              :key="item.BusinessTypeId"
              :label="item.BusinessType"
              :value="item.BusinessTypeId"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>

    <!-- 明细 -->
    <el-button
      type="primary"
      @click="onCustomTable"
      icon="el-icon-s-tools"
      style="margin: 30px 0 10px 10px"
    >
      明细项
    </el-button>
    <el-table
      ref="table"
      :row-key="(row) => row.Prop"
      :data="subList"
      @selection-change="handleSelectionChange"
      stripe
      border
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <template v-for="(item, index) in tableColumns">
        <!-- 需判断是否有价格的权限  -->
        <template v-if="item.IsShow">
          <el-table-column
            :key="`${item.Prop}-${index}`"
            :prop="item.Prop"
            v-if="shouldShowColumn(item)"
            :label="item.Label"
            :align="item.Align ?? 'left'"
            :min-width="item.Width"
            show-overflow-tooltip
          >
            <template slot-scope="{ row }">
              <span v-if="isNumericProperty(item.Prop)">
                {{ $commonJs.toThousands(row[item.Prop]) }}
              </span>
              <span v-else>
                {{ row[item.Prop] }}
              </span>
            </template>
          </el-table-column>
        </template>
      </template>
    </el-table>
    <customTableDialog
      ref="customTableDialog"
      @onSave="onSave"
      :initTableData="tableColumns"
      tableType="销货单明细"
    />
    <!-- 明细 -->
    <!-- <el-table class="subItem-table" :data="subList" @selection-change="handleSelectionChange" border
      :summary-method="summaryFunc" show-summary>
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="left" label="存货编码" min-width="140px">
        <template slot-scope="{ row }">
          <span>{{ row.ProductNo }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" prop="ProductName" label="存货名称" min-width="140px"
        show-overflow-tooltip></el-table-column>
      <el-table-column align="left" label="规格型号">
        <template slot-scope="{ row }">
          <span>{{ row.ProductSpec }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="颜色" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.ColorName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="销售单位">
        <template slot-scope="{ row }">
          <span>{{ row.SaUnitName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="SaQuantity" label="数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.SaQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="计量单位2" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.UnitName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="Quantity2" label="数量2">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Quantity2) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="换算率">
        <template slot-scope="{ row }">
          <span>{{ row.Rate }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="最新含税进价" min-width="120px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.PurchasePrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="最新含税售价" min-width="120px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.SalePrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="最低售价" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.RetailPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="报价" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.QuotedPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="折扣%" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.Discount }}</span>
        </template>
      </el-table-column>
      <el-table-column align="left" label="税率%" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.TaxRate }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="单价" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.Price }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" label="含税单价" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ row.TaxPrice }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="Amount" label="金额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.Amount) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="TaxLimit" label="税额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.TaxLimit) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="TaxAmount" label="含税金额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.TaxAmount) }}</span>
        </template>
      </el-table-column>
      <el-table-column align="right" prop="DiscountAmount" label="折扣金额" min-width="100px" v-if="canPrice">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toThousands(row.DiscountAmount) }}</span>
        </template>
      </el-table-column> -->
    <!-- <el-table-column align="center" label="预计交货日期" min-width="180px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toDateString(row.DeliveryDate) }}</span>
        </template>
      </el-table-column> -->

    <!-- <el-table-column align="center" label="行中止">
        <template slot-scope="{ row }">
          <el-checkbox v-model="row.LineAbort" :disabled="true"></el-checkbox>
        </template>
      </el-table-column> -->
    <!-- <el-table-column align="center" label="中止人">
        <template slot-scope="{ row }">
          <span>{{ row.LineAbortEmpName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="中止时间" min-width="100px">
        <template slot-scope="{ row }">
          <span>{{ $commonJs.toDateString(row.LineAbortDate) }}</span>
        </template>
      </el-table-column> -->
    <!-- <el-table-column align="center" label="已采购数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.PurchaseQuantity }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="已采购数量2" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.PurchaseQuantity2 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="累计生产数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.ProductionQuantity }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="累计生产数量2" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.ProductionQuantity2 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="执行数量" min-width="120px">
        <template slot-scope="{ row }">
          <span>{{ row.ExecutionQuantity }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="执行数量2">
        <template slot-scope="{ row }">
          <span>{{ row.ExecutionQuantity2 }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="来源单据">
        <template slot-scope="{ row }">
          <span>{{ row.SourceTypeName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="来源单号" min-width="180px">
        <template slot-scope="{ row }">
          <span>{{ row.DocNo }}</span>
        </template>
      </el-table-column>
    
      <el-table-column align="center" label="可用量">
        <template slot-scope="{ row }">
          <span>{{ row.LineAbortEmpName }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="现存量">
        <template slot-scope="{ row }">
          <span>{{ row.ExistQuantity }}</span>
        </template>
      </el-table-column> -->
    <!-- </el-table> -->
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import customTableDialog from "@/components/common/customTableDialog/customTableDialog";

import tableColumn from "@/data/business/sales/sale/list.json";
import tableParam from "@/data/business/sales/sale/query.json";

export default {
  mixins: [listMixin],
  components: { list, customTableDialog },
  props: {
    isShow: {
      type: Boolean,
      default: true,
    },
    is_listDialog: {
      typeof: Boolean,
      default: false,
    },
    isSelect: {
      typeof: Boolean,
      default: false,
    },
    // canPrice: {
    //   type: Boolean,
    //   default: true,
    // },
  },
  provide() {
    return {
      IsDefaultMonth: false,
    };
  },
  data() {
    return {
      api: require("@/api/sa/saDoc").default,
      sourceTypeApi: require("@/api/ba/sourceType").default,
      businessTypeApi: require("@/api/ba/businessType").default,
      FieldSettingApi: require("@/api/sy/fieldSetting").default,
      show: false,
      orderNo: "",
      TradeUnitId: 0,
      FullName: "",
      WarehouseId: 0,
      WarehouseName: "",
      subList: [],
      subSelectList: [],
      params: {
        BusinessTypeId: null,
      },
      tempParams: {},
      businessTypeList: [],
      ordertype: "",
      show:false,
      tableColumns:[],
      summaryShow: false,
      total: 0,
    };
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice("/business/sales/sale");
    },
  },
  // props: {
  //   is_listDialog: {
  //     typeof: Boolean,
  //     default: false,
  //   },
  // },
  activated() {
    this.getRouterInfo();
  },
  mounted() {
    this.getBusinessType();
    if (!this.$permission.canPrice("/business/sales/sale")) {
      const list = this.$refs.list;
      const findIndex = list.tableList.findIndex(
        (item) => item.tableName == "Amount"
      );
      list.tableList.splice(findIndex, 1);
    }
    this.getTableColumns();
  },
  methods: {
    /** 价格权限的字段 */
    shouldShowColumn(item) {
      if (!item.IsShow) return false;
      const priceProps = [
        "PurchasePrice",
        "SalePrice",
        "RetailPrice",
        "QuotedPrice",
        "Discount",
        "TaxRate",
        "Price",
        "TaxPrice",
        "Amount",
        "TaxLimit",
        "TaxAmount",
        "DiscountAmount",
      ];
      return (
        (this.canPrice && priceProps.includes(item.Prop)) ||
        !priceProps.includes(item.Prop)
      );
    },
    /** 千位符格式化数字类型 */
    isNumericProperty(prop) {
      return ["SubQuantity", "Amount"].includes(prop);
    },
    async getTableColumns() {
      const res = await this.FieldSettingApi.list({ Type: "销货单明细" });
      this.tableColumns = [];
      this.tableColumns = res.Data;
    },
    onCustomTable() {
      this.$refs.customTableDialog.dialogVisible = true;
    },
    onSave() {
      this.getTableColumns();
      this.$message.success("保存成功");
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    getBusinessType() {
      this.sourceTypeApi.list({}).then((res) => {
        if (res.Code == 0) {
          this.SourceTypeIdArr = res.Data;
          let params = "销货单";
          let index = this.SourceTypeIdArr.findIndex(
            (item) => item.SourceType == params
          );
          let SourceTypeId = this.SourceTypeIdArr[index].SourceTypeId;
          this.businessTypeApi
            .getSourceTypeToBusinessType(SourceTypeId)
            .then((res) => {
              if (res.Code == 0) {
                this.businessTypeList = res.Data;
              }
            });
        }
      });
    },
    getRouterInfo() {
      if (this.$router.history.current.params) {
        this.tempParams.SourceDocNo = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.SourceDocNo,
        };
        this.tempParams.OrderType = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.OrderType,
        };
        this.tempParams.Ids = {
          paramValueType: "resetParamValue",
          isReset: true,
          value: this.$router.history.current.params.Ids,
        };
        this.$refs.list.getData();
      }
    },
    // 选择报价明细
    handleSelectionChange(data) {
      data.forEach((e) => {
        e.WarehouseId = e.WarehouseId || this.WarehouseId;
        e.WarehouseName = e.WarehouseName || this.WarehouseName;
      });
      this.subSelectList = data;
      console.log("?!!!@", data);
    },
    toggleRow(data) {
      this.show = true;

      // console.log('object',data);
      // if (!this.is_listDialog) return;
      console.log(data, "data");
      this.orderNo = data.DocNo;

      this.TradeUnitId = data.TradeUnitId;
      this.FullName = data.FullName;
      this.WarehouseId = data.WarehouseId;
      this.WarehouseName = data.WarehouseName;

      if (this.isSelect) {
        data.Products.forEach((item) => {
          if (this.ordertype == "销售出库单") {
            item.SaQuantity =
              item.SaQuantity - (item.StOutDocOccupyQuantity ?? 0);
          } else {
            item.SaQuantity =
              item.SaQuantity - (item.SaDocInvoiceOccupyQuantity ?? 0);
          }

          item.Amount = item.SaQuantity * item.Price;
          item.TaxAmount = item.SaQuantity * item.TaxPrice;
        });

        let tList = data.Products.filter((x) => x.SaQuantity != 0);
        console.log("tList", tList);
        this.subList = tList;
      } else {
        this.subList = data.Products;
      }

      // if (this.subList.length > 0) this.show = true;
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    
    getDataFunc(params) {
      console.log("getDataFunc", params);
      return new Promise((resolve, reject) => {
        this.api.docList(params).then(res => {
          let times = Math.ceil(res.Count / params.pageSize);
          //判断是否最后一页
          if (times == params.pageIndex) {
            this.api.docListTotal(params).then(res => {
              console.log("total", res)
              if (res.Code == 0 && res.Data) {
                this.total = res.Data[0];
                this.summaryShow = true;
              } else {
                this.summaryShow = false;
              }
            })
          } else {
            this.summaryShow = false;
          }
          resolve(res);
        })
      })
    },
    /** 千位符加两位小数 */
    summaryFunc(param) {
      console.log("summaryFunc", param.columns)
      const { columns, data } = param;
      var fields = ["BaseQuantity", "SubQuantity",'Amount']; //需要合计的字段
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (index === 1) console.log("data", column, data);
        //数量 getQuantity
        const arr1 = ["SaQuantity", "Quantity2"];
        //金额 固定2位小数
        const arr2 = [
          "Amount",
          "TaxLimit",
          "TaxAmount",
          "DiscountAmount",
          "CostPrice",
          "CostAmount",
        ];
        const values = data.map((item) => Number(item[column.property]));
        if (
          !values.every((value) => isNaN(value)) &&
          (arr1.indexOf(column.property) > -1 ||
            arr2.indexOf(column.property) > -1)
        ) {
          var v = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (arr1.indexOf(column.property) != -1) {
            v = Number(v);
          }
          if (arr2.indexOf(column.property) != -1) {
            v = v.toFixed(2);
            let vStr = v.toString().split(".");
            if (Number(vStr[1]) <= 0) v = vStr[0];
          }
          if (v > 0) {
            v = Number(v).toLocaleString();
          }
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    reviewAll(ids) {
      this.api.reviewAll({ ids }).then((res) => {
        var that = this;
        this.$message({
          showClose: true,
          duration: 0,
          dangerouslyUseHTMLString: true,
          message: `<div class="my-message">${res.Msg}</div>`,
          onClose: function () {
            that.reload();
          },
        });
      });
    },
    backAll(ids) {
      this.api.backAll({ ids }).then((res) => {
        var that = this;
        this.$message({
          showClose: true,
          duration: 0,
          dangerouslyUseHTMLString: true,
          message: `<div class="my-message">${res.Msg}</div>`,
          onClose: function () {
            that.reload();
          },
        });
      });
    },
  },
};
</script>
<style lang="scss">
.my-message {
  max-height: 500px;
  max-width: 600px;
  line-height: 18px;
  overflow-y: auto;
  padding: 5px;
}
</style>
<style lang="scss" scoped>
.subItem-table {
  margin-top: 30px;
}
</style>
